import { z } from 'zod';

import { normalizeGrants, permissionGrantSchema } from './permissions.ts';

// Request bodies shared by the API (validation) and the web app (forms).
// Error messages are shown to users, so they are in Spanish.

const name = z
  .string()
  .trim()
  .min(1, 'El nombre es obligatorio')
  .max(100, 'El nombre no puede tener más de 100 caracteres');

export const listMembersQuerySchema = z.strictObject({
  /** Also list former members (ended), shown by their membership display_name. */
  includeFormer: z.enum(['true', 'false']).optional(),
});
export type ListMembersQuery = z.infer<typeof listMembersQuerySchema>;

export const updateMemberSchema = z
  .strictObject({
    roleId: z.uuid('Rol no válido').optional(),
    teamId: z.uuid('Equipo no válido').nullable().optional(),
    status: z.enum(['active', 'suspended', 'ended']).optional(),
    /**
     * HU-CON-17: when deactivating someone with contacts, deals or properties, the
     * member who receives all of them (required then).
     */
    reassignTo: z.uuid('Elige a quién pasan sus registros').optional(),
  })
  .refine((v) => Object.keys(v).length > 0, 'No hay cambios');
export type UpdateMemberInput = z.infer<typeof updateMemberSchema>;

/** Grants like "records.view:team" or "users.manage"; deduplicated to the widest scope. */
const grants = z.array(permissionGrantSchema).max(100).transform(normalizeGrants);

export const createRoleSchema = z.strictObject({ name, permissions: grants });
export type CreateRoleInput = z.infer<typeof createRoleSchema>;

export const updateRoleSchema = z
  .strictObject({
    name: name.optional(),
    permissions: grants.optional(),
  })
  .refine((v) => Object.keys(v).length > 0, 'No hay cambios');
export type UpdateRoleInput = z.infer<typeof updateRoleSchema>;

export const teamSchema = z.strictObject({ name });
export type TeamInput = z.infer<typeof teamSchema>;
